module.exports = __webpack_public_path__ + "75bcd10bd62c36381a36c50fd834d0df.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-4.png
// module id = 2204
// module chunks = 0